import { render, staticRenderFns } from "./shareIntOrder.vue?vue&type=template&id=4f13d830&scoped=true"
import script from "./shareIntOrder.vue?vue&type=script&lang=js"
export * from "./shareIntOrder.vue?vue&type=script&lang=js"
import style0 from "./shareIntOrder.vue?vue&type=style&index=0&id=4f13d830&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f13d830",
  null
  
)

export default component.exports